import React from 'react'

const TimeRangeContainer = ( {timeRanges, handleTimeRangeSetting, selectedRange, addClass='' }) => {
    return (
        <div className={`inline-flex flex-wrap rounded-md min-h-[35px] ${addClass}`} role="group">
            {timeRanges.map((range, index) => (
                <button
                    key={range.value}
                    onClick={() => handleTimeRangeSetting(range.value)}
                    className={`
                        px-4 py-2 text-sm font-medium
                        ${index === 0 ? 'rounded-l-lg' : ''}
                        ${index === timeRanges.length - 1 ? 'rounded-r-lg' : ''}
                        ${selectedRange === range.value
                            ? 'dashboard-stock-year-selected'
                            : 'bg-white text-green-900 hover:bg-gray-100'
                        }
                        border border-gray-200
                        ${index !== 0 ? 'border-l-0' : ''}
                        transition-colors duration-200
                    `}
                >
                    {range.label}
                </button>
            ))}
        </div>
    )
}

export default TimeRangeContainer